import React from 'react';
import { MenuItem, Select } from '@mui/material';

import { Option } from 'lib/types';
import { OrderScenarioOptions } from '../model/Order';

const ANY_SCENARIO = 'ANY';

interface OrderScenarioFilterProps {
    onChange: (value?: string) => void;
    value?: string;
}

export const OrderScenarioFilter: React.FC<OrderScenarioFilterProps> = ({ value, onChange }) => {
    const handleStateChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.value === ANY_SCENARIO) {
                onChange(undefined);
            } else {
                onChange(e.target.value);
            }
        },
        [onChange]
    );
    const renderOption = React.useCallback(
        (option: Option) => (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        ),
        []
    );
    return (
        <Select
            value={value ?? ANY_SCENARIO}
            onChange={handleStateChange}
            variant="outlined"
            size="small"
            sx={{ backgroundColor: 'background.paper' }}
        >
            <MenuItem value={ANY_SCENARIO}>All Scenarios</MenuItem>
            {OrderScenarioOptions.map(renderOption)}
        </Select>
    );
};
